import { api } from '@/lib/api-client';
import { TeamUser } from '@/types/team';

export async function fetchTeamRoster(
  teamId: string | undefined,
): Promise<TeamUser[]> {
  try {
    if (!teamId) {
      throw new Error('Must pass a teamId');
    }
    return await api.get(`/teams/${teamId}/roster`);
  } catch (error) {
    throw new Error('Failed to fetch team roster');
  }
}
